import { createEntityAdapter } from '@ngrx/entity';
import { ComposantEntityState } from '@get/api-interfaces';
import { CustomEntityState } from '@get/store/configs/states';

export type IState = CustomEntityState<ComposantEntityState>;

export const adapter = createEntityAdapter<ComposantEntityState>({
  selectId: o => o.idComposant
});
export const initialState: IState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const composantFeatureKey = 'composant';
